/**
 * Brickox-style horizontal process: hover flex nudge; click expands one column (accordion).
 * Desktop (lg+) only. CTA links keep default navigation (no toggle).
 */
export function initStepsAccordion(loco) {
  const grid = document.querySelector(".accordion-strip [data-accordion-strip]");
  if (!grid) return;

  const items = [...grid.querySelectorAll(".accordion-strip__item")];
  if (!items.length) return;

  const mq = window.matchMedia("(min-width: 992px)");

  const bumpLoco = () => loco?.bump?.(780);

  const applyAria = () => {
    const open = grid.classList.contains("has-expanded");
    items.forEach((el) => {
      const expanded = open && el.classList.contains("is-expanded");
      el.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  };

  const collapseAll = () => {
    grid.classList.remove("has-expanded");
    items.forEach((el) => el.classList.remove("is-expanded"));
    applyAria();
    bumpLoco();
  };

  const expandOne = (item) => {
    items.forEach((el) => el.classList.remove("is-expanded"));
    item.classList.add("is-expanded");
    grid.classList.add("has-expanded");
    applyAria();
    bumpLoco();
  };

  const handleActivate = (item) => {
    if (!mq.matches) return;
    if (item.classList.contains("is-expanded")) return;
    expandOne(item);
  };

  const expandFirst = () => {
    expandOne(items[0]);
  };

  items.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (!mq.matches) return;
      if (e.target.closest(".accordion-strip__cta")) return;
      handleActivate(item);
    });

    item.addEventListener("keydown", (e) => {
      if (!mq.matches) return;
      if (e.target.closest(".accordion-strip__cta")) return;
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      handleActivate(item);
    });
  });

  applyAria();

  mq.addEventListener("change", (e) => {
    if (!e.matches) collapseAll();
    else expandFirst();
  });
}
